module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kR5Pj"))).then(() => parcelRequire('hEqeo'));